import React, { useEffect, useState, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Container, Nav, NavItem, NavLink, Row, Col, Collapse } from 'reactstrap';

import { StyledButton } from './shared/styled';
import userService from './user/UserService';

const CollapsibleNavItem = ({ header, defaultOpen, children }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen ?? false);

  const toggle = () => setIsOpen(true);

  return (
    <>
      <NavItem 
        onClick={toggle} 
        className={`collapsible-header ${isOpen ? 'open' : 'closed'}`}
      >
        {header}
      </NavItem>

      <Collapse className='collapsible-body' isOpen={isOpen}>
        {children}
      </Collapse>
    </>
  )
}

const WithSideNav = ({ children }) => {
  const history = useHistory();
  
  const [sideBarData, setSideBarData] = useState([]);
  
  const fetchData = useCallback(async () => {
    const hasProfile = await userService.hasProfile();
    if (!hasProfile) {
      history.push('/user/profile');
    } else {
      const homePageData = await userService.getSideBar();
      setSideBarData(homePageData);
    }
  }, [history, setSideBarData]);

  useEffect(() => {
    fetchData()
  }, [fetchData]);

  // todo - do we need these? they are empty but being passed as props to other components below
  // eric: these are works in progress, unimplemented functionality
  const openSearch = () => {};

  return (
    <Container>
      <Row>
        <Col xs="4" sm="4" md="3" xl="3">
          <Nav vertical id="sidebar">
            {sideBarData?.map(({ classes: studentClasses, school: { name: schoolName } }) => 
              <div className="school-listing">
                <CollapsibleNavItem defaultOpen header={schoolName}>
                  {studentClasses?.map(({ name: nameOfClass, classId }) => 
                    <NavItem>
                      <NavLink tag={Link} to={`/classes/${classId}`}>
                        {nameOfClass}
                      </NavLink>
                    </NavItem>
                  )}
                </CollapsibleNavItem>
              </div>
            )}
            
            <StyledButton onClick={openSearch} fullWidth>Search</StyledButton>
          </Nav>
        </Col>
        <Col>
          {children}
        </Col>
      </Row>
    </Container>
  );
}

export default WithSideNav;